<template>
  <div id="content" class="loginpage">
    <div class="container  text-center">

      <div class="row">
        <div class="col-12">
          <form class="login-form" >
            <img :src="require('@/assets/logo_innopearl.png')"  class="sidebar_logo mb-5" alt="">
            <div class="col-12 mb-6 text-center">
              <h3>Add new administrator / expert  </h3>
            </div>
            <div class="row mb-3">
              <span class="fieldTitle">Name</span>
              <div class="col-12 col-md-6">
                <input type="text" id="firsname" placeholder="Firstname" v-model="input.firstname" />
                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.firstname.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.firstname.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <input type="text" id="lastname" placeholder="Lastname" v-model="input.lastname" />
                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.lastname.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.lastname.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <span class="fieldTitle">Function</span>
              <div class="col-12">
                <!-- <input type="text" id="fuction" placeholder="Function" v-model="input.function_in" /> -->
                <v-autocomplete v-model="input.function_in" closable-chips  :items="function_in_possibles" item-color="#FFF" item-title="name" item-value="value"  label="Function" chips multiple></v-autocomplete>

                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.function_in.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.function_in.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <span class="fieldTitle">Entreprise</span>
              <div class="col-12">
                <input type="text" id="entreprise" placeholder="Entreprise" v-model="input.entreprise" />
                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.entreprise.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.entreprise.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
            </div>
              <div class="row mb-3">
                <span class="fieldTitle">Industry</span>
              <div class="col-12">
                <!-- <input type="text" id="industry" placeholder="Industry" v-model="input.industry" /> -->
                <v-autocomplete v-model="input.industry" closable-chips  :items="industry_possibles" item-color="#FFF" item-title="name" item-value="value" label="Industry" chips multiple></v-autocomplete>

                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.industry.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.industry.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <span class="fieldTitle">Profile picture</span>
              <div class="col-12 text-left">
                <input type="file" id="logo"   accept="image/*"/>

              </div>
            </div>
            <!-- <div class="row mb-3">
            <div class="col-12">
                <input type="text" id="username" placeholder="Username" v-model="input.username" />
                <div class="alert alert-warning text-left mt-3 " v-if="v$.input.username.$errors.length > 0">
                    <div  v-for="(error, index) of v$.input.username.$errors" :key="index">{{ error.$message }}</div>
                </div>
            </div>
          </div> -->

          <div class="row mb-3">
            <span class="fieldTitle">Role</span>
          <div class="col-12">
            <select id="role" v-model="input.role">
                  <option disabled value="">Please select a role</option>
                  <option value="Admin">Admin</option>
                  <option value="Expert">Expert</option>
                  </select>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.role.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.role.$errors" :key="index">{{ error.$message }}</div>
              </div>
          </div>
        </div>
        <div class="row mb-6">
          <span class="fieldTitle">Professional phone number</span>
        <div class="col-12">
            <input type="tel" id="phone" placeholder="Professional phone" v-model="input.phone" />
            <div class="alert alert-warning text-left mt-3 " v-if="v$.input.phone.$errors.length > 0">
                <div  v-for="(error, index) of v$.input.phone.$errors" :key="index">{{ error.$message }}</div>
            </div>
        </div>
      </div>
          <div class="row mb-6">
            <span class="fieldTitle">Account email</span>
          <div class="col-12">
              <input type="email" id="email" placeholder="Professional email" v-model="input.email" />
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.email.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.email.$errors" :key="index">{{ error.$message }}</div>
              </div>
          </div>
        </div>

            <button class="btn next_step_btn" type="submit" v-on:click.prevent = "createData()">
              CREATE AN ACCOUNT
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  </template>

<script>
 import {toast } from 'vue-sonner'
 import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import api from '../tools/api';
export default {
  name: 'RegisterView',
  components: {

  },
  setup () {
   return { v$: useVuelidate() }
  },
  data(){
    return{
      apiUrl: process.env.VUE_APP_API_URL,
        input:{
            // username: "",
            email: "",
            firstname: "",
            lastname: "",
            function_in:null,
            entreprise: "",
            industry: null,
            role: "Expert",
            phone: "",
        },
        function_in_possibles : [],
        industry_possibles :[],
    }
  },
  validations () {
   return {
     input:{
       // username: {
       //   required,
       // },
       firstname: {
         required,
       },
       lastname: {
         required,
       },
       phone:{
         required
       },
       function_in: {
         required,
       },
       entreprise: {
         required,
       },
       industry: {
         required,
       },
       role: {required},
       email: { required, email } // Matches this.contact.email
     }

   }
 },
  methods: {
    async register_partial(){
      const isFormCorrect = await this.v$.$validate()
     // alert(isFormCorrect);
      if(isFormCorrect){
        api.post(process.env.VUE_APP_API_URL+"/restrict/register_admin",this.input,{
          headers: {
              'Content-Type': 'application/json',
          }
        }).then( (r) => {
          console.log(r);
          toast.success("A new user has been  added. An email for a password setup has been sent to their provided address.")
        }).catch( (e) => {
          console.log(e);
          if(e.response.data)toast.error(e.response.data);
          else toast.error("Sorry, an error occurred. Please try again. ");
        })
  //      this.$router.push("/register_confirm/12345");
      }
    },
    async createData () {
      const isFormCorrect = await this.v$.$validate()
     // alert(isFormCorrect);
      if(isFormCorrect){
         var formData = new FormData()
         var file = document.getElementById('logo').files[0]
         formData.append('pic', file)
         formData.append('firstname', this.input.firstname)
         formData.append('lastname', this.input.lastname)
         formData.append('function_in', this.input.function_in)
         formData.append('entreprise', this.input.entreprise)
         formData.append('industry', this.input.industry)
         formData.append('email', this.input.email)
         formData.append('role', this.input.role)
         formData.append('phone', this.input.phone)
         const headers = { 'Content-Type': 'multipart/form-data' }
         api.post(this.apiUrl+'/restrict/admin_register_logo', formData, { headers }).then((res) => {
           console.log(res.data)
           toast.success("Thank you for signing up! To get started, please check your email to create a password. We've sent you a verification email to ensure that your account is secure and can only be accessed by you")

         }).catch((error) => {
           // error.response.status Check status code
           console.log(error)
           toast.error("Sorry, an error occurred. Please try again. ");

         })
       }
       },
  },
  mounted(){
    api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_userfunction").then( (r) => {
      console.log(r);
      this.function_in_possibles = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
    else toast.error("Sorry, an error occurred. Please try again. ")
    });
    api.get(process.env.VUE_APP_API_URL+"/restrict/dict/dict_industry").then( (r) => {
      console.log(r);
      this.industry_possibles = r.data
    }).catch( (e) => {
    if(e.response.status == 403)toast.error("To request access to this resource, please contact us");
    else toast.error("Sorry, an error occurred. Please try again. ")
    });
    //  this.$store.commit('LOGOUT')
  },
}
</script>
<style media="screen">
.loginpage{
  padding: 50px;
}
.loginpage form{
  background: #FFF;
  padding: 50px;
  border-radius: 20px;
  max-width: 800px;
margin: auto;
}

.loginpage form input,
.loginpage form select{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: 100%;
height: 40px;
padding: 5px;
}
.next_step_btn,
.next_step_btn:hover{
  background: #3783C5 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border: 1px solid #3783C5;
  border-radius: 50px;
  opacity: 1;
  padding: 14px 37px;
  color:#FFF;
  margin:5px;
}
.sidebar_logo{
  width: 180px;

}

.fieldTitle{
  text-align:left;
  color:#3783C5;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 5px;
  margin-top: 10px;
}
</style>
